export const BOT_PROCESSING_PROGRESS_EVENT = "bot-processing-progress:start";
export const BOT_PROCESSING_COMPLETED_EVENT =
  "bot-processing-progress:completed";
export const BOT_PROCESSING_DELETED_EVENT = "bot-processing-progress:deleted";

export const emitBotProcessingProgressStart = (botId) => {
  if (!botId || typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(BOT_PROCESSING_PROGRESS_EVENT, {
      detail: { botId },
    }),
  );
};

export const emitBotProcessingCompleted = (botId, knowledgeSourceIds = []) => {
  if (!botId || typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(BOT_PROCESSING_COMPLETED_EVENT, {
      detail: { botId, knowledgeSourceIds },
    }),
  );
};

export const emitBotProcessingDeleted = (botId, knowledgeSourceIds = []) => {
  if (!botId || typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(BOT_PROCESSING_DELETED_EVENT, {
      detail: { botId, knowledgeSourceIds },
    }),
  );
};
